export default __webpack_public_path__ + "static/media/Thief's Wristbands of the Final Way.79e6de83.jpg";